import {getWebSocketTransport} from '#/utils/get-websocket-transport';
import {Chain, createPublicClient} from 'viem';
import {UsePublicClientReturnType} from 'wagmi';

export const useSafeWebSocketPublicClient = (
  publicClient: UsePublicClientReturnType | undefined,
  chain: Chain | undefined,
) => {
  if (!chain) return;

  const transport = getWebSocketTransport(chain);
  if (!transport) return publicClient;

  const webSocketPublicClient = createPublicClient({chain, transport});
  return webSocketPublicClient;
};
